<template>
    <div class="relief">
      <div class="box">
        <p id="text">{{text}}</p>
      </div>
    </div>
</template>

<script>
    export default {
        name: "relief",
        mounted(){
			this.timer=setInterval(function(){
				let width=-$('#text').width()
				let left =$('#text').position().left
				if(left> width){
					left-=1
				}else{
					left=0
				}
				$('#text').css("left",left)
			},24)
        },
		destroyed(){
			window.clearInterval(this.timer)
		},
        data:()=>{
            return{
              text:'本宣传资料所涉及的户型仅供示意参考，其装修、家具、陈设等非交付标准，不属于交付范围。不同户型的面积尺寸、功能布局、空间分割、门窗/管井形态位置等均有不同。相同户型因楼栋、楼层、单元等差别，局部结构、面积等也可能不同，具体以政府部门最终审定的图纸和销售合同为准。',
				timer:'',
			}
        },
		methods:{
			
			}

    }
</script>

<style scoped>
	.relief{
		width: 100%;
		height:8px;
		position: fixed;
		bottom: 8%;
		left: 0;
        opacity: 0.5;
        z-index: 20;
	}
	.box{
		height: 8px;
		width: 100%;
		line-height: 8px;
		/*background-color: rgba(0,0,0,0.5);*/
		position: relative;
		 white-space:pre-wrap;
	}
	p{
		line-height:8px;
		font-size:4px;
		position: absolute;
		padding-left: 20px;
		padding-right: 20px;
		top: 0;
		left: 0;
		 white-space:nowrap;
		 color: #aaa;
		 font-family: "微软雅黑";
		 /* animation: run 30s linear infinite; */
		 
	}
	@keyframes run{
		from{
			left: 0;
		}
		to{
			left: -100%;
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/hxRelief.vue